import { safeLocalStorage, safeSessionStorage } from "@helpers/storage";

const STORAGE_KEY = "redirectAfterLogin";

// sessionStorage is per tab. localStorage is shared, so a logged-out tab
// on /transactions was applied when another tab refreshed.
function discardSharedRedirect() {
    safeLocalStorage.removeItem(STORAGE_KEY);
}

export function saveCurrentPathForRedirect() {
    discardSharedRedirect();
    safeSessionStorage.setItem(
        STORAGE_KEY,
        window.location.pathname + window.location.search,
    );
}

export function popRedirectPath(): string | null {
    discardSharedRedirect();
    const path = safeSessionStorage.getItem(STORAGE_KEY);
    if (path) {
        safeSessionStorage.removeItem(STORAGE_KEY);
    }
    return path;
}

export function resolveLoginRedirectTarget(hash: string): string | null {
    const savedPath = popRedirectPath();
    if (savedPath) {
        return savedPath;
    }
    if (hash.includes("access_token")) {
        return "/";
    }
    return null;
}
